import React from 'react'
import './Showcase.css'

const Showcase = () => {
  return (
      <div>
          <section className="showcase-area " id="showcase">
              <div className="showcase-cantainer ">
                  <h1 className="main-title">Eat Right Food</h1>
                  <p>Eat Healthy food,it is good for your health</p>
                  <a className="btn btn-primary" href="#food-menu">MENU</a>
              </div>
          </section>
      </div>
  )
}

export default Showcase